import { useConfig as hook, BaseConfig } from '@eika-infrastruktur/config-provider';

export interface Config extends BaseConfig {
    texts: {
        tabTitleFind: string;
        tabTitleValidate: string;
        tabContentFind: string;
        tabContentValidate: string;
        inputLabelIban: string;
        inputLabelAccount: string;
        errorInvalidAccount: string;
        errorAccountLength: string;
        errorNotValid: string;
        successMessageIban: string;
        successMessageValid: string;
        copyButtonText: string;
    };
}

export const defaultConfig: Config = {
    texts: {
        tabTitleFind: 'Finn ditt iban',
        tabTitleValidate: 'Sjekk ditt iban',
        tabContentFind: 'Skriv inn kontonummeret ditt for å finne IBAN nummeret.',
        tabContentValidate:
            'Skriv inn IBAN nummeret ditt for å se om det er riktig skrevet. Vi kan ikke si om nummeret eksisterer, kun om formatet er riktig.',
        inputLabelIban: 'IBAN nummer (15 siffer)',
        inputLabelAccount: 'Kontonummer (11 siffer)',
        errorInvalidAccount: 'Ugyldig kontonummer',
        errorAccountLength: 'Kontonummer må være minimum 11 siffer',
        errorNotValid: 'Feil IBAN',
        successMessageIban: 'Ditt IBAN er: ',
        successMessageValid: 'Korrekt IBAN',
        copyButtonText: 'Kopier',
    },
};

function createHook<T>(): () => T {
    return () => hook<T>();
}

export const useConfig = createHook<typeof defaultConfig>();
